import React, { useCallback } from "react";
import { DiseaseMenuSection, diseaseMenuSectionId } from "./DiseaseMenuSection";
import { HashLink } from "react-router-hash-link";

export const DiseaseKnowledgeDetailIndex = React.memo(function DiseaseKnowledgeDetailIndex(props: Props) {
    const { activeSection } = props;

    const renderLink = useCallback((section: DiseaseMenuSection, label: string, sectionsForJudge: DiseaseMenuSection[] = [section]) => {
        const to = `#${diseaseMenuSectionId(section)}`;
        const active = activeSection ? sectionsForJudge.includes(activeSection) : false;
        // TODO: detail_index__activeを付与したい
        const activeClassName = active ? "" : "";
        return <HashLink to={to} smooth className={`detail_index__link ${activeClassName}`}>{label}</HashLink>;
    }, [activeSection]);

    return (
        <ul className={"detail_index__itemIndex"}>
            <li className={"detail_index__itemIndexShikkanTitle"}>{renderLink(DiseaseMenuSection.ABSTRACT_DISEASE, "疾患の概要", [])}</li>
            <li className={"detail_index__itemIndexContents"}>{renderLink(DiseaseMenuSection.ABSTRACT_DISEASE, "病気の概要")}</li>
            <li className={"detail_index__itemIndexContents"}>{renderLink(DiseaseMenuSection.SYMPTOM, "主な症状")}</li>
            <li className={"detail_index__itemIndexContents"}>{renderLink(DiseaseMenuSection.MISLEADING_DISEASE, "症状に変化があった場合他に疑った方がいい病気")}</li>
            <li className={"detail_index__itemIndexAdviceTitle"}>{renderLink(DiseaseMenuSection.WATCH, "ケアマネジメントにおけるアドバイス", [])}</li>
            <li className={"detail_index__itemIndexContents"}>{renderLink(DiseaseMenuSection.WATCH, "日常生活の注意点")}</li>
            <li className={"detail_index__itemIndexContents"}>{renderLink(DiseaseMenuSection.ASSESMENT_CHECKPOINT, "アセスメント作成時のチェックポイント")}</li>
            <li className={"detail_index__itemIndexContents"}>{renderLink(DiseaseMenuSection.SUGGESTING_SERVICE, "検討を進めるサービス")}</li>
            <li className={"detail_index__itemIndexContents"}>{renderLink(DiseaseMenuSection.ADVICE, "熟練ケアマネからのワンポイントアドバイス")}</li>
        </ul>
    );
});

type Props = {
    activeSection: DiseaseMenuSection | null,
};
